import { render } from "./FedexPickupPage.vue?vue&type=template&id=7757f0fc&scoped=true"
import script from "./FedexPickupPage.vue?vue&type=script&lang=js"
export * from "./FedexPickupPage.vue?vue&type=script&lang=js"

import "./FedexPickupPage.vue?vue&type=style&index=0&id=7757f0fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7757f0fc"]])

export default __exports__